import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

const OFFICE_TYPE = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'];

@Component({
  templateUrl: './modal-doc-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalDocPreviewComponent {
  constructor(@Inject(DIALOG_DATA) public data) {}

  public viewer(extension: string) {
    return OFFICE_TYPE.includes(extension) ? 'google' : 'url';
  }
}
